<template>
  <div>
    <el-card class="mb5">
      <el-form
        ref="queryForm"
        :model="queryForm.params"
        label-position="top"
        size="small"
        @submit.native.prevent
      >
        <el-row :gutter="20">
          <el-col :span="6">
            <!-- 客户类型 -->
            <el-form-item :label="$t('customerManagements.customerType')">
              <el-select
                v-model="queryForm.params.source"
                :placeholder="$t('operationCenter.PleaseSelect')"
                clearable
                style="width: 100%"
              >
                <el-option :label="$t('customerManagements.all')" value="" />
                <el-option :label="$t('customerManagements.enterprise')" value="corporation" />
                <el-option :label="$t('customerManagements.personal')" value="person" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 客户编号 -->
            <el-form-item :label="$t('customerManagements.clientID')">
              <el-input
                v-model.trim="queryForm.params.id"
                :placeholder="$t('collectionCenter.inputNum')"
                clearable
                maxlength="6"
                show-word-limit
                style="width: 100%"
                @input="idInput"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- CNPJ -->
            <el-form-item label="CNPJ">
              <el-input
                v-model.trim="queryForm.params.cnpjMother"
                :placeholder="$t('operationCenter.PleaseEnterTheContent')"
                clearable
                size="small"
                @input="changeCnpjMother"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 账号名称 -->
            <el-form-item :label="$t('customerManagements.AccountName')">
              <el-input
                v-model="queryForm.params.username"
                :placeholder="$t('operationCenter.PleaseEnterTheContent')"
                clearable
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 公司名称 -->
            <el-form-item :label="$t('customerManagements.CompanyName')">
              <el-input
                v-model="queryForm.params.company"
                :placeholder="$t('operationCenter.PleaseEnterTheContent')"
                clearable
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 网点： -->
            <el-form-item :label="$t('collectionCenter.dot')">
              <el-select
                v-model="queryForm.params.siteId"
                :placeholder="$t('operationCenter.PleaseSelect')"
                clearable
                filterable
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in siteIdList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 账户状态： -->
            <el-form-item :label="$t('customerManagements.AccountStatus')">
              <el-select
                v-model="queryForm.params.lockState"
                :placeholder="$t('operationCenter.PleaseSelect')"
                clearable
                filterable
                style="width: 100%"
              >
                <el-option :key="1" :label="$t('customerManagements.all')" :value="null" />
                <el-option :key="2" :label="$t('customerManagements.enable')" :value="0" />
                <el-option :key="3" :label="$t('customerManagements.Disable')" :value="1" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <!-- 审核状态 -->
            <el-form-item :label="$t('customerManagements.ApprovalStatus')">
              <el-select
                v-model="queryForm.params.auditState"
                :placeholder="$t('operationCenter.PleaseSelect')"
                clearable
                filterable
                style="width: 100%"
              >
                <el-option :key="1" :label="$t('customerManagements.all')" :value="null" />
                <el-option :key="2" :label="$t('customerManagements.NotAudit')" :value="0" />
                <el-option :key="3" :label="$t('customerManagements.approved')" :value="1" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card>
      <div class="flx-between" style="margin-bottom: 15px">
        <div>
          <!-- 搜索 -->
          <el-button
            icon="el-icon-search" size="mini" type="primary"
            @click="getData((find = 1))"
          >{{ $t('operationCenter.Procurar') }}
          </el-button>
          <!-- 重置 -->
          <el-button icon="el-icon-refresh" size="mini" @click="queryFormReset">{{ $t('operationCenter.reset') }}
          </el-button>
        </div>
      </div>
      <div style="margin-bottom: 10px">
        <el-button
          v-permit:remove="'btn:customer-managements:list:add'"
          icon="el-icon-plus"
          size="mini"
          type="primary"
          @click.stop="goPage({}, typeObj.add.code)"
        >{{ $t('customerManagements.addCustomer') }}
        </el-button>
        <el-button
          v-permit:remove="'btn:customer-managements:list:export'"
          size="mini"
          type="primary"
          @click.stop="exportTableData()"
        >{{ $t('collectionCenter.export') }}
        </el-button>
      </div>
      <el-row>
        <el-col :span="4" style="height: 520px !important; overflow-y: auto">
          <el-tree
            :data="dataTree" :highlight-current="true" :props="defaultProps"
            class="my-tree"
          >
            <div slot-scope="{ node, data }" class="custom-tree-node ellipsis" style="width: 100px">
              <div
                :class="{
                  'custom-origan-tree-node': data['children'] && data['children'].length
                }"
                :title="node.label"
                class="ellipsis span-label"
                @click="onClickNode(node.data)"
              >
                {{ node.label }}
              </div>
            </div>
          </el-tree>
        </el-col>
        <el-col :span="20">
          <el-table
            :data="tableData"
            :header-cell-style="{ background: '#f2f2f2', color: 'black' }"
            :height="520"
            border
          >
            <el-table-column
              :label="$t('customerManagements.clientID')"
              prop="id"
              width="120"
            /><!-- 客户编号 -->
            <!-- 账号名称 -->
            <el-table-column :label="$t('customerManagements.AccountName')" width="140">
              <template slot-scope="scope">
                <div v-if="scope.row.username">
                  <el-popover placement="bottom-start" popper-class="copy" trigger="hover">
                    <!--复制-->
                    <el-button
                      style="color: black; font-size: 15px; padding: 5px !important"
                      type="text"
                      @click="copy(scope.row.username)"
                    >{{ $t('orderDetails.copy') }}
                    </el-button>
                    <div slot="reference" class="is-click-column sleTwo">
                      <el-tooltip
                        v-if="scope.row.username.length > 29"
                        :content="scope.row.username"
                        class="item"
                        effect="dark"
                        placement="top"
                      >
                        <div
                          class="is-click-column sleTwo"
                          @click.stop="goPage(scope.row, typeObj.examine.code, scope.$index)"
                        >
                          {{ scope.row.username }}
                        </div>
                      </el-tooltip>
                      <div
                        v-else
                        class="is-click-column sleTwo"
                        @click.stop="goPage(scope.row, typeObj.examine.code, scope.$index)"
                      >
                        {{ scope.row.username }}
                      </div>
                    </div>
                  </el-popover>
                </div>
              </template>
            </el-table-column>
            <!-- 账户别称 -->
            <el-table-column
              :label="$t('customerManagements.AccountNickname')"
              :show-overflow-tooltip="true"
              prop="customerAlias"
              width="160"
            />
            <!-- 公司名称 -->
            <el-table-column
              :label="$t('customerManagements.CompanyName')"
              :show-overflow-tooltip="true"
              prop="company"
              width="150"
            >
              <template slot-scope="scope">
                <el-popover placement="bottom-start" popper-class="copy" trigger="hover">
                  <!--复制-->
                  <el-button
                    style="color: black; font-size: 15px; padding: 5px !important"
                    type="text"
                    @click="copy(scope.row.company)"
                  >{{ $t('orderDetails.copy') }}
                  </el-button>
                  <span slot="reference">{{ scope.row.company }}</span>
                </el-popover>
              </template>
            </el-table-column>
            <!-- 税号 -->
            <el-table-column
              :label="$t('trajectory.TaxID')"
              :show-overflow-tooltip="true"
              prop="cnpjMother"
              width="140"
            >
              <template slot-scope="scope">
                <el-popover placement="bottom-start" popper-class="copy" trigger="hover">
                  <!--复制-->
                  <el-button
                    style="color: black; font-size: 15px; padding: 5px !important"
                    type="text"
                    @click="copy(scope.row.cnpjMother)"
                  >{{ $t('orderDetails.copy') }}
                  </el-button>
                  <span slot="reference">{{ scope.row.cnpjMother }}</span>
                </el-popover>
              </template>
            </el-table-column>
            <!-- 客户类型 -->
            <el-table-column
              :label="$t('customerManagements.customerType')"
              align="center"
              prop="coPrincipalName"
              width="130"
            >
              <template slot-scope="scope">
                <!-- 企业 -->
                <el-tag v-if="scope.row.source === 'corporation'">{{ $t('customerManagements.enterprise') }}
                </el-tag>
                <!-- 个人 -->
                <el-tag v-else-if="scope.row.source === 'person'" type="success">{{ $t('customerManagements.personal') }}
                </el-tag>
                <span v-else>/</span>
              </template>
            </el-table-column>
            <!-- 客户渠道 -->
            <el-table-column
              :label="$t('customerManagements.channels')"
              align="center"
              prop="channel"
              width="140"
            />
            <!-- 审核状态 -->
            <el-table-column
              :label="$t('customerManagements.ApprovalStatus')"
              align="center"
              prop="coPrincipalName"
              width="140"
            >
              <template slot-scope="scope">
                <el-tag v-if="scope.row.auditState === 0" type="info">{{ $t('customerManagements.NotAudit') }}
                </el-tag>
                <el-tag v-else type="success">{{ $t('customerManagements.approved') }}</el-tag>
              </template>
            </el-table-column>
            <!-- 账户状态 -->
            <el-table-column
              :label="$t('customerManagements.AccountStatus')"
              align="center"
              prop="coPrincipalName"
              width="140"
            >
              <template slot-scope="scope">
                <!-- 启用 -->
                <el-tag v-if="scope.row.lockState === 0" type="success">{{ $t('customerManagements.enable') }}
                </el-tag>
                <!-- 停用 -->
                <el-tag v-else type="danger">{{ $t('customerManagements.Disable') }}</el-tag>
              </template>
            </el-table-column>
            <!-- 网点 -->
            <el-table-column :label="$t('userManage.site')" prop="siteName" width="140" />
            <!-- 创建人 -->
            <el-table-column :label="$t('userManage.creator')" prop="createName" width="140" />
            <!-- 创建时间 -->
            <el-table-column
              :label="$t('CenterForSorting.CreationTime')"
              prop="createTime"
              width="160"
            />
            <!-- 创建网点 -->
            <el-table-column
              :label="$t('customerManagements.createSiteName')"
              prop="createSiteName"
              width="140"
            />
            <!-- 修改人 -->
            <el-table-column
              :label="$t('CenterForSorting.ModifiedBy')"
              prop="updateName"
              width="140"
            />
            <!-- 修改时间 -->
            <el-table-column
              :label="$t('CenterForSorting.ModificationTime')"
              prop="updateTime"
              width="160"
            />
            <!-- 修改网点 -->
            <el-table-column
              :label="$t('customerManagements.updateSiteName')"
              prop="updateSiteName"
              width="140"
            />
            <!-- 操作 -->
            <el-table-column :label="$t('operationCenter.operate')" fixed="right" width="155">
              <template slot-scope="scope">
                <el-popover placement="bottom-start" trigger="click">
                  <div>
                    <!-- 编辑 -->
                    <el-button
                      v-permit:remove="'btn:customer-managements:list:edit'"
                      size="mini"
                      type="success"
                      @click.stop="goPage(scope.row, typeObj.edit.code, scope.$index)"
                    >{{ $t('operationCenter.Edit') }}
                    </el-button>
                    <div v-permit:remove="'btn:customer-managements:list:audit'" class="fl">
                      <!-- 账户审核 -->
                      <el-button
                        v-if="scope.row.auditState === 0"
                        class="ml10"
                        size="mini"
                        type="warning"
                        @click.stop="goPage(scope.row, typeObj.set.code)"
                      >{{ $t('customerManagements.Approval') }}
                      </el-button>
                      <template v-else>
                        <div v-permit:remove="'btn:customer-managements:list:lock'">
                          <!-- 账户启用 -->
                          <el-button
                            v-if="scope.row.lockState === 1"
                            class="ml10"
                            size="mini"
                            type="warning"
                            @click.stop="goPage(scope.row, typeObj.set.code)"
                          >{{ $t('ChannelManage.enable') }}
                          </el-button>
                          <!-- 账户停用 -->
                          <el-button
                            v-else
                            class="ml10"
                            size="mini"
                            type="danger"
                            @click.stop="goPage(scope.row, typeObj.set.code)"
                          >{{ $t('ChannelManage.Disable') }}
                          </el-button>
                        </div>
                      </template>
                    </div>
                    <!-- 重置密码 -->
                    <el-button
                      v-permit:remove="'btn:customer-managements:list:reset-pwd'"
                      class="ml10"
                      size="mini"
                      type="danger"
                      @click.stop="handleResetPwd(scope.row.id)"
                    >{{ $t('customerManagements.resetPassword') }}
                    </el-button>
                  </div>
                  <el-button slot="reference" size="mini">{{ $t('operationCenter.MoreActions') }}
                  </el-button>
                </el-popover>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination">
            <!-- 分页工具 -->
            <el-pagination
              :current-page.sync="queryForm.pageNumber"
              :page-size.sync="queryForm.pageSize"
              :page-sizes="[10, 20, 50, 100]"
              :total="total"
              background
              layout="total, sizes, prev, pager, next, jumper"
              style="margin: 10px 0"
              @current-change="getData((find = 0))"
              @size-change="getData((find = 0))"
            />
          </div>
        </el-col>
      </el-row>
    </el-card>
    <el-drawer
      :title="drawerObj.title"
      :visible.sync="drawerObjVisible"
      :wrapper-closable="true"
      direction="ltr"
      size="65%"
      @close="closeDrawer"
    >
      <tab-cmp
        v-if="drawerObjVisible"
        ref="tabCmps"
        :currency-obj="currencyObj"
        :customer-type="drawerObj.customerType"
        :send-arr="sendArr"
        @resetPwd="handleResetPwd"
        @updataData="updataData"
      />
    </el-drawer>
    <!-- 重置密码 -->
    <el-dialog
      :close-on-click-modal="true"
      :title="$t('customerManagements.resetPassword')"
      :visible.sync="resetPwdObj.visible"
      width="30%"
    >
      <reset-pwd-cmp
        v-if="resetPwdObj.visible"
        :ids="resetPwdObj.ids"
        @handleCancel="resetPwdObj.visible = false"
        @handleDetermine="handleDetermine"
      />
    </el-dialog>

    <!--    充值金额-->
    <!--                          '充值金额' : '修改信用额度' -->
    <el-dialog
      :close-on-click-modal="false"
      :title="rechargeType === 1 ? '充值金额' : $t('customerManagements.ModifyCreditLimit')"
      :visible.sync="showType"
      width="40%"
    >
      <div>
        <el-form
          ref="recharge"
          :model="recharge"
          :rules="rules"
          class="queryFormClass"
          label-width="100px"
        >
          <el-form-item v-if="rechargeType === 1" label="充值金额:" prop="rechargeAmount">
            <el-input
              v-model="recharge.rechargeAmount"
              :placeholder="$t('customerManagements.pleaseInput')"
              clearable
            />
          </el-form-item>
          <!-- 信用额度： -->
          <el-form-item
            v-if="rechargeType === 2"
            :label="$t('customerManagements.creditsL')"
            prop="creditLimit"
          >
            <el-input
              v-model="recharge.creditLimit"
              :placeholder="$t('customerManagements.pleaseInput')"
              clearable
            />
          </el-form-item>
        </el-form>
      </div>
      <div style="text-align: right">
        <el-button size="small" type="info" @click="updataAmount(0)">{{ $t('customerManagements.cancel') }}
        </el-button>
        <!-- 取消 -->
        <el-button size="small" type="primary" @click="updataAmount(1)">{{ $t('customerManagements.confirm') }} </el-button><!-- 确定 -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { searchSiteIdList } from '@/api/lanshou';
import {
  apiCustomerListPage,
  apiResetPassword,
  exportCustomerList,
  getCustomerTree
} from '@/api/customer';
// import { apiAddressBook } from '@/api/orderApi';
import { getUserIdAndNameObj } from '@/enums/storageEnum';
import { getUserName } from '@/utils/asyncTools';
import { TYPY_OBJ } from '@/enums/customerEnums';
import { priceType } from '@/utils/validate';
import { NODE_TYPE } from '@/enums/messageRecordEnums';
import { goResourceTaskList } from '@/utils/goExportList';
// import { currencyTypePage, changeCreditLimit } from '@/api/finance/partition';
import { copyData } from '@/utils/copyData';

export default {
  name: 'CustomerList',
  components: {
    // 'customer-cmp': CustomerCmp
    'tab-cmp': () => import('./TabsCmp'),
    'reset-pwd-cmp': () => import('./cmp/ResetPwdCmp')
    // 'msg-cmp': () => import('@/components/SendMessage/index')
  },

  data() {
    return {
      drawerObj: {
        title: '新增客户',
        customerType: {
          id: '', // 客户id
          customerAlias: '', // 客户别名
          type: ''
        }
      },
      drawerObjVisible: false,
      queryForm: {
        pageSize: 20,
        pageNumber: 1,
        params: {
          source: '',
          id: '',
          username: '',
          company: '',
          siteId: '',
          cnpjMother: '',
          lockState: null,
          auditState: null
        }
      },
      siteIdList: [], // 站点list

      tableData: [],
      total: 0,

      userObj: [],

      typeObj: TYPY_OBJ,
      // queryBoxShow: true,

      resetPwdObj: {
        visible: false,
        ids: 0
      },
      sendArr: [], // 手机人地址簿
      recharge: {
        creditLimit: '', // 信用额度
        rechargeAmount: '' // 充值金额
      },
      rechargeType: 1,
      showType: false,
      rechargeId: 1,
      rules: {
        creditLimit: [{ required: true, validator: priceType, trigger: ['blur', 'change'] }],
        rechargeAmount: [{ required: true, validator: priceType, trigger: ['blur', 'change'] }]
      },

      msgArr: [], // 发送信息
      currencyObj: [], // 币种
      channelList: [], // 客户渠道list
      dataTree: [],
      defaultProps: {
        children: 'children',
        label: 'username'
      }
    };
  },

  created() {
    this.getData(1);
    this.userObj = getUserIdAndNameObj();

    this.NODE_TYPE = NODE_TYPE;

    searchSiteIdList().then((res) => {
      if (res.code === 200) {
        res.data.forEach((data) => {
          this.siteIdList.push({ id: data.id, name: data.name });
        });
      }
    });
  },

  methods: {
    onClickNode(data) {
      console.log(data, 'onClickNode');
      // @click.stop="(scope.row, typeObj.examine.code, scope.$index)"
      this.goPage(data, this.typeObj.examine.code);
    },
    // 点击复制
    copy(data) {
      copyData(data);
    },

    // 导出
    exportTableData() {
      const paramForm = JSON.parse(JSON.stringify(this.queryForm));
      paramForm.params.cnpjMother = this.queryForm.params.cnpjMother.replace(/[^0-9a-zA-Z]/g, '');
      exportCustomerList(paramForm.params).then((res) => {
        if (res.code === 200) {
          goResourceTaskList();
        }
      });
    },
    idInput(value) {
      this.queryForm.params.id = value.replace(/[^\d]/g, '');
    },
    changeCnpjMother(value) {
      this.queryForm.params.cnpjMother = value.replace(/[\u4e00-\u9fa5]/g, '');
    },
    // 充值、修改信用额度
    rechargeClick(id, type) {
      this.rechargeId = id;
      this.rechargeType = type;
      this.showType = true;
    },

    getData(find) {
      if (find === 1) {
        this.queryForm.pageNumber = 1;
      }
      const paramForm = JSON.parse(JSON.stringify(this.queryForm));
      paramForm.params.cnpjMother = this.queryForm.params.cnpjMother.replace(/[^0-9a-zA-Z]/g, '');
      this.getCustomerTreeData(paramForm);
      apiCustomerListPage(paramForm)
        .then((res) => {
          if (res.code === 200) {
            this.total = res.data.total;
            this.tableData = res.data.records.map((item) => {
              const creatUserName = getUserName(item.createUser, this.userObj);
              return {
                ...item,
                creatUserName,
                integral: item.integral || 0,
                level: item.level || 0
              };
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    async getCustomerTreeData(data) {
      const res = await getCustomerTree(data.params);
      if (res.code === 200) {
        this.dataTree = res.data;
      }
    },
    /**
     * 置空
     */
    queryFormReset() {
      for (const key in this.queryForm.params) {
        this.queryForm.params[key] = '';
      }
      this.getData(1);
    },

    /**
     * 跳转到详情或者新增页面
     */
    goPage({ id, customerAlias, deliveryNoteFlag }, type, index) {
      this.drawerObjVisible = true;
      this.drawerObj.customerType.id = id;
      this.drawerObj.customerType.type = type;
      this.drawerObj.customerType.customerAlias = customerAlias;
      this.drawerObj.customerType.deliveryNoteFlag = deliveryNoteFlag;
      // this.drawerObj.title = TYPY_OBJ[type].name;

      if (type === TYPY_OBJ.add.code) {
        // 新增
        this.drawerObj.title = this.$t('customerManagements.add');
        this.$store.dispatch('user/getManagerList', '');
      } else if (type === TYPY_OBJ.edit.code) {
        this.drawerObj.title = this.$t('customerManagements.edit');
        // 判断有没有经办人，没有请求第一页列表
        if (index && this.tableData[index].handlerId) {
          this.$store
            .dispatch('user/getManagerList', this.tableData[index].handlerName)
            .then((res) => {
              this.getData(1);
            });
        } else {
          this.$store.dispatch('user/getManagerList', '');
        }
        // 编辑
      } else if (type === TYPY_OBJ.examine.code) {
        this.drawerObj.title = this.$t('customerManagements.View');
        // 判断有没有经办人，没有请求第一页列表
        if (index && this.tableData[index].handlerId) {
          this.$store.dispatch('user/getManagerList', this.tableData[index].handlerName);
          this.getData(1);
        } else {
          this.$store.dispatch('user/getManagerList', '');
        }
        // 查看
      } else {
        this.drawerObj.title = this.$t('customerManagements.Approval');
        console.log(type);
      }
    },
    closeDrawer() {
      this.drawerObjVisible = false;
    },
    updataData(isBool = true) {
      this.getData();
      if (isBool) {
        this.drawerObjVisible = false;
      }
    },

    // 重置
    handleResetPwd(ids) {
      console.log(ids, 'idsids');
      this.resetPwdObj.ids = ids;
      this.resetPwdObj.visible = true;
    },

    // 修改密码
    handleDetermine(obj) {
      apiResetPassword(obj)
        .then((res) => {
          if (res.code !== 200) {
            return;
          }
          this.$message({
            message: this.$t('customerManagements.resetSucceeded'), // 重置密码成功
            type: 'success'
          });
          this.resetPwdObj.visible = false;
          this.getData(find);
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.ml10 {
  margin-left: 10px;
}

.fl {
  display: inline-block;
}

.putAway {
  position: absolute;
  right: 0;
  top: 0;
  color: #1989fa;
  cursor: pointer;
  z-index: 100;
}

/* 外层类名约束，不用deep */
.my-tree .el-tree-node:not(.is-leaf) .el-tree-node__label {
  font-weight: bold;
}

.my-tree .el-tree-node.is-current .el-tree-node__label {
  font-weight: bold;
  background-color: #e8f3ff;
}

.custom-origan-tree-node {
  font-weight: bold;
}
</style>
